import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import assetProcessingActivitiesApi from 'config/api/assetProcessingActivities/assetProcessingActivities';
import { getAxiosErrorUserMessage, triggerBlobDownload } from 'helpers/instanceExportDownload/instanceExportDownload';
import processing_activities_messages from 'messages/processing_activities_messages';

type DownloadAssetProcessingDpiaLogInput = {
  assetProcessingActivityId: number;
  fallbackFileName?: string;
  organizationId: number;
};

const useDownloadAssetProcessingDpiaLog = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const messages = processing_activities_messages.asset_ropa.apa_editor.sections.dpia_log;

  return useMutation(
    ({ assetProcessingActivityId, fallbackFileName, organizationId }: DownloadAssetProcessingDpiaLogInput) =>
      assetProcessingActivitiesApi.downloadDpiaLog(organizationId, assetProcessingActivityId, fallbackFileName),
    {
      onSuccess: ({ blob, fileName }) => {
        triggerBlobDownload(blob, fileName);
      },
      onError: async (err: unknown) => {
        const message = await getAxiosErrorUserMessage(err, t(messages.download_failed));
        enqueueSnackbar(message, { variant: 'error' });
      },
    },
  );
};

export default useDownloadAssetProcessingDpiaLog;
